import ACTION_TYPES from 'constants/ACTION_TYPES';
import SERVICE_TYPES from 'constants/SERVICE_TYPES';
import { select, put } from 'redux-saga/effects';
import api from '../api/api';

function* fetchArticles(page = 1, per_page = 10, apiUrl, searchTerm = '', commented = 'all', featured = 'all', trending = 'all', brand = 'all', sorting = 'all') {
    let endpoint = `/community/posts?post_type=article&page=${page}&per_page=${per_page}`;
    if (!!searchTerm) {
        endpoint += `&term=${searchTerm}`;
    }
    if (commented !== 'all') {
        endpoint += `&is_answered=${commented}`;
    }
    if (featured !== 'all') {
        endpoint += `&is_featured=${featured}`;
    }
    if (trending !== 'all') {
        endpoint += `&is_trending=${trending}`;
    }
    if (brand !== 'all') {
        endpoint += `&brands=${brand}`;
    }
    if (sorting !== 'all') {
        endpoint += `&sort=${sorting}`;
    }

    const getSelectedRegion = state => state.user.selectedRegion;
    const selectedRegion = yield select(getSelectedRegion);

    const json = yield api.get(endpoint, apiUrl, selectedRegion, SERVICE_TYPES.COMMUNITY);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_ARTICLES_RESPONSE,
            data: {
                list: json.results,
                page: json.page,
                per_page: json.per_page,
                total: json.total,
                total_pages: json.total_pages,
            },
        });
    }
}

function* getArticle(articleId, apiUrl){
    let url = `/community/posts/${articleId}`;
    const json = yield api.get(url, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_ARTICLE_RESPONSE,
            data: json,
        });
    }
}

function* delArticle(articleId, apiUrl) {
    const json = yield api.del(`/community/posts/${articleId}`, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_SELECT_ARTICLE,
            data: null,
        });
        yield fetchArticles(null,null,apiUrl,null,null,null,null,null,null);
    }
}

function* updateArticle(article, apiUrl) {
    const { id } = article;
    delete article.id;
    const json = yield api.put(`/community/posts/${id}`, article, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_UPDATE_ARTICLE_RESPONSE,
            data: json,
        });
    }
}

function* fetchComments(page = 1, per_page = 10, articleId, searchTerm = '', sorting = 'all', apiUrl){
    let url = `/community/posts?post_type=comment&include=flags&parent_id=${articleId}&page=${page}&per_page=${per_page}`;
    if (!!searchTerm) {
        url += `&term=${searchTerm}`;
    }
    if (sorting !== 'all') {
        url += `&sort=${sorting}`;
    }
    const json = yield api.get(url, apiUrl, 'all', SERVICE_TYPES.COMMUNITY);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_COMMENTS_PER_ARTICLE_RESPONSE,
            data: {
                list: json.results,
                page: json.page,
                per_page: json.per_page,
                total: json.total,
                total_pages: json.total_pages,
            },
        });
    }
}

function* fetchFlags(page = 1, per_page = 10, articleId, status = 'all', sorting = 'all', apiUrl){
    let url = `/community/flags?resource_type=post&parent_id=${articleId}&page=${page}&per_page=${per_page}`;
    if (sorting !== 'all') {
        url += `&sort=${sorting}`;
    }
    if (status !== 'all') {
        url += `&status=${status}`;
    }
    const json = yield api.get(url, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_ARTICLE_FLAGS_RESPONSE,
            data: {
                list: json.results,
                page: json.page,
                per_page: json.per_page,
                total: json.total,
                total_pages: json.total_pages,
            },
        });
    }
}

function* updateReasonFlags(flag,apiUrl){
    const { id } = flag;
    delete flag.id;
    const json = yield api.put(`/community/flags/${id}`, flag, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_UPDATE_ARTICLE_FLAGS_REASON_RESPONSE,
            data: json,
        });
    }
}

function* addTag(articleId, tagId, apiUrl) {
    const json = yield api.post(
        '/community/content_tags',
        {
            content_type: 'Post',
            content_id: articleId,
            tag_id: tagId,
        },
        apiUrl
    );
    if (json) {
        yield getArticle(articleId, apiUrl);
    }
}
function* removeTag(articleId, tagId, apiUrl) {
    const json = yield api.del(
        `/community/content_tags/Post/${articleId}/${tagId}`,
        apiUrl
    );
    if (json) {
        yield getArticle(articleId, apiUrl);
    }
}

function* getArticleFiles(articleId, apiUrl) {
    const json = yield api.get(
        `/community/assets?assetable_type=Post&assetable_id=${articleId}&per_page=100`,
        apiUrl
    );
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_ARTICLE_FILES_RESPONSE,
            data: json.results,
        });
    }
}

function* postAsset(articleId, brandIdent, asset_type, slot, file, done, apiUrl) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('brand_ident', brandIdent);
    formData.append('assetable_id', articleId);
    formData.append('asset_type', asset_type);
    formData.append('slot', slot);
    formData.append('assetable_type', 'Post');
    const json = yield api.postForm('/community/assets',formData,apiUrl);
    if (json.status_code && ![200, 201, 202].includes(json.status_code)) {
        alert(json.message);
    } else {
        if (done) done();

        yield getArticleFiles(articleId, apiUrl);
    }
}

function* deleteAsset(assetId, articleId, apiUrl) {
    const json = yield api.del('/community/assets/' + assetId, apiUrl);
    if (json) {
        console.log('file Deleted');
        if(articleId){
            yield getArticleFiles(articleId, apiUrl);
        }
    }
}

function* assignAsset(articleId, assetId, apiUrl) {
    const json = yield api.post(`/community/assets/${assetId}/assign`, {}, apiUrl);
    if (json) {
        yield getArticle(articleId, apiUrl);
    }
}
function* unAssignAsset(articleId, assetId, apiUrl) {
    const json = yield api.post(`/community/assets/${assetId}/unassign`, {}, apiUrl);
    if (json) {
        yield getArticle(articleId, apiUrl);
    }
}

function* fetchTranslations(articleId, page = 1, per_page = 10, apiUrl) {
    const json = yield api.get(
        `/community/translations?resource_type=Post&resource_id=${articleId}&page=${page}&per_page=${per_page}`,
        apiUrl
    );
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_FETCH_ARTICLE_TRANSLATIONS_RESPONSE,
            data: {
                list: json.results,
                page: json.page,
                per_page: json.per_page,
                total: json.total,
                total_pages: json.total_pages,
            },
        });
    }
}

function* postTranslation(resource_id, translation, apiUrl) {
    const json = yield api.post(
        `/community/translations`,
        {
            resource_id,
            resource_type: 'Post',
            ...translation,
        },
        apiUrl
    );
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_POST_ARTICLE_TRANSLATION_RESPONSE,
            data: json,
        });
    }
}

function* deleteTranslation(
    translationId,
    articleId,
    page,
    perPage,
    apiUrl
) {
    const json = yield api.del(`/community/translations/${translationId}`, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_SELECT_ARTICLE_TRANSLATION,
            data: null,
        });
        yield fetchTranslations(articleId, page, perPage, apiUrl);
    }
}

function* updateTranslation(translation, apiUrl) {
    const json = yield api.put(
        `/community/translations/${translation.id}`,
        translation,
        apiUrl
    );
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_UPDATE_ARTICLE_TRANSLATION_RESPONSE,
            data: json,
        });
    }
}

function* postArticle(article, apiUrl) {
    const json = yield api.post(`/community/posts`, article, apiUrl);
    if (json) {
        yield put({
            type: ACTION_TYPES.CS_POST_ARTICLE_RESPONSE,
            data: json,
        });
    }
}

function* csArticlesWorker(apiUrl, action) {
    switch (action.type) {
        case ACTION_TYPES.CS_ARTICLES_REQUEST:
            yield fetchArticles(
                action.data?.page,
                action.data?.per_page,
                apiUrl,
                action.data?.searchTerm,
                action.data?.commented,
                action.data?.featured,
                action.data?.trending,
                action.data?.brand,
                action.data?.sorting,
            );
            break;
        case ACTION_TYPES.CS_FETCH_ARTICLE_REQUEST:
            yield getArticle(action.data, apiUrl);
            break;
        case ACTION_TYPES.CS_DELETE_ARTICLE_REQUEST:
            yield delArticle(action.data, apiUrl);
            break;
        case ACTION_TYPES.CS_UPDATE_ARTICLE_REQUEST:
            yield updateArticle(action.data, apiUrl);
            break;
        case ACTION_TYPES.CS_POST_ARTICLE_REQUEST:
            yield postArticle(action.data, apiUrl);
            break;
        case ACTION_TYPES.CS_FETCH_COMMENTS_PER_ARTICLE_REQUEST:
            yield fetchComments(
                action.data?.page,
                action.data?.per_page,
                action.data?.articleId,
                action.data?.searchTerm,
                action.data?.sorting,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_FETCH_ARTICLE_FLAGS_REQUEST:
            yield fetchFlags(
                action.data?.page,
                action.data?.per_page,
                action.data?.articleId,
                action.data?.status,
                action.data?.sorting,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_UPDATE_ARTICLE_FLAGS_REASON_REQUEST:
            yield updateReasonFlags(
                action.data,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_ADD_TAG_TO_ARTICLE_REQUEST:
            yield addTag(action.data.articleId, action.data.tagId, apiUrl);
            break;
        case ACTION_TYPES.CS_REMOVE_TAG_FROM_ARTICLE_REQUEST:
            yield removeTag(action.data.articleId, action.data.tagId, apiUrl);
            break;
        case ACTION_TYPES.CS_FETCH_ARTICLE_FILES_REQUEST:
                yield getArticleFiles(action.data, apiUrl);
                break;
        case ACTION_TYPES.CS_POST_ARTICLE_FILE_REQUEST:
            yield postAsset(
                action.data?.articleId,
                action.data?.brandIdent,
                action.data?.assetType,
                action.data?.slot,
                action.data?.file,
                action.data?.done,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_DELETE_ARTICLE_FILE_REQUEST:
            yield deleteAsset(
                action.data?.assetId,
                action.data?.articleId,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_ASSIGN_ASSET_REQUEST:
            yield assignAsset(
                action.data?.articleId,
                action.data?.assetId,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_UNASSIGN_ASSET_REQUEST:
            yield unAssignAsset(
                action.data?.articleId,
                action.data?.assetId,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_FETCH_ARTICLE_TRANSLATIONS_REQUEST:
            yield fetchTranslations(
                action.data?.articleId,
                action.data?.page,
                action.data?.per_page,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_POST_ARTICLE_TRANSLATION_REQUEST:
            yield postTranslation(
                action.data?.resourceId,
                action.data?.translation,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_DELETE_ARTICLE_TRANSLATION_REQUEST:
            yield deleteTranslation(
                action.data?.translationId,
                action.data?.articleId,
                action.data?.page,
                action.data?.per_page,
                apiUrl
            );
            break;
        case ACTION_TYPES.CS_UPDATE_ARTICLE_TRANSLATION_REQUEST:
            yield updateTranslation(action.data, apiUrl);
            break;
        default:
            break;
    }
}

export default csArticlesWorker;
